import { getLocalTimeZone, now } from "@internationalized/date";
import {} from "./types.js";
export function getUTCNow() {
    return now("UTC");
}
export function getLocalNow() {
    return now(getLocalTimeZone());
}
export function getYesterday() {
    return getLocalNow().subtract({ days: 1 });
}
export function startOfDay(date, min) {
    const result = date.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
    return min && result.compare(min) < 0 ? min : result;
}
export function endOfDay(date, max) {
    const result = date.set({ hour: 23, minute: 59, second: 59, millisecond: 999 });
    return max && result.compare(max) > 0 ? max : result;
}
export const DATE_RANGE_PRESETS = [
    { key: "last24h", label: "Last 24h", duration: { hours: 24 } },
    { key: "last7d", label: "Last 7d", duration: { weeks: 1 } },
    { key: "last14d", label: "Last 14d", duration: { weeks: 2 } },
    { key: "last30d", label: "Last 30d", duration: { days: 30 } },
    { key: "last60d", label: "Last 60d", duration: { days: 60 } },
    { key: "last90d", label: "Last 90d", duration: { days: 90 } },
];
export function getPresetRange(key, end) {
    const preset = DATE_RANGE_PRESETS.find((p) => p.key === key);
    if (!preset) {
        throw new Error(`Unknown date range preset: ${key}`);
    }
    const endValue = end ?? getLocalNow();
    return {
        start: endValue.subtract(preset.duration),
        end: endValue,
    };
}
export function getRFC3339WithoutTime(zdt) {
    return `${zdt.year}-${String(zdt.month).padStart(2, "0")}-${String(zdt.day).padStart(2, "0")}`;
}
/**
 * Serialize a `ZonedDateTime` as plain RFC 3339 with offset, e.g.
 * `2026-06-01T00:00:00+02:00`.
 *
 * `ZonedDateTime.toString()` emits IXDTF (RFC 9557): RFC 3339 with a trailing
 * `[IANA/Name]` annotation — `2026-06-01T00:00:00+02:00[Europe/Berlin]`. Most
 * servers (including Go's `time.Parse(time.RFC3339, …)`) reject the bracketed
 * form, so we strip the annotation.
 *
 * Use this for endpoints that do tz-aware bucketing: the backend recovers the
 * caller's offset from the parsed timestamp's Location and keeps day buckets
 * aligned to the client's local calendar day.
 *
 * For endpoints that hit precomputed UTC daily rollups (model usage, generic
 * metrics), keep using `getRFC3339WithoutTime` — those tables can't be
 * re-bucketed per client tz.
 */
export function toRFC3339WithOffset(zdt) {
    return zdt.toString().replace(/\[.*?\]$/, "");
}
